import request from "@/utils/request";

export function getInfo(params) {
  return request({
    url: "/CheckOutApplication/GetStudentInfo",
    method: "get",
    params
  });
}
export function submit(data) {
  return request({
    url: "/CheckOutApplication/Submit",
    method: "post",
    data
  });
}
export function isLate(params) {
  return request({
    url: "/CheckOutApplication/IsLate",
    method: "get",
    params
  });
}
